// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__Ew9rc","subheader":"ReorderModal_subheader__q1s1Z","listWrap":"ReorderModal_listWrap__euIjJ"};